import { Drawer as VaulDrawer } from 'vaul'

import { DrawerBody } from './drawer-body'
import { DrawerContent } from './drawer-content'
import { DrawerHeader } from './drawer-header'

export const Drawer = {
    Root: VaulDrawer.Root,
    NestedRoot: VaulDrawer.NestedRoot,
    Trigger: VaulDrawer.Trigger,
    Header: DrawerHeader,
    Body: DrawerBody,
    Content: DrawerContent,
    Close: VaulDrawer.Close,
} as const
